module.exports = "<div class=\"ibox-content sk-loading loading-box\" [class.sk-loading]=\"isLoading\">\r\n    <sk-spinner class=\"sk-spinner sk-spinner-fading-circle\"></sk-spinner>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-4\" *ngFor=\"let item of items\">\r\n            <psm-clickable-box [item]=\"item\"></psm-clickable-box>\r\n        </div>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/clickableBox/clickableBoxList.component.html
// module id = ./src/app/components/common/clickableBox/clickableBoxList.component.html
// module chunks = main